"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _cache, _org;
Object.defineProperty(exports, "__esModule", { value: true });
const ethers_1 = require("ethers");
const abis_1 = require("../../abis");
class ContractCache {
    constructor(org) {
        _cache.set(this, void 0);
        _org.set(this, void 0);
        __classPrivateFieldSet(this, _cache, new Map());
        __classPrivateFieldSet(this, _org, org);
    }
    async loadContractFromOrg(appName) {
        if (__classPrivateFieldGet(this, _cache).has(appName)) {
            return __classPrivateFieldGet(this, _cache).get(appName);
        }
        else {
            const appAddress = (await __classPrivateFieldGet(this, _org).app(appName)).address;
            const appContract = new ethers_1.Contract(appAddress, abis_1.abis.get(appName), __classPrivateFieldGet(this, _org).connection.ethersProvider);
            __classPrivateFieldGet(this, _cache).set(appName, appContract);
            return appContract;
        }
    }
    async loadContractFromStateVariable(contract, stateVariable, abiName) {
        if (__classPrivateFieldGet(this, _cache).has(stateVariable)) {
            return __classPrivateFieldGet(this, _cache).get(stateVariable);
        }
        else {
            const keyAddress = await contract[stateVariable]();
            const keyContract = new ethers_1.Contract(keyAddress, abis_1.abis.get(abiName), __classPrivateFieldGet(this, _org).connection.ethersProvider);
            __classPrivateFieldGet(this, _cache).set(stateVariable, keyContract);
            return keyContract;
        }
    }
}
_cache = new WeakMap(), _org = new WeakMap();
exports.default = ContractCache;
//# sourceMappingURL=ContractCache.js.map